import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import { postWithHeaders } from '../../../server/actions';
import NotificationSystem from 'react-notification-system';
import {
    _addNotificationError,
    allowNumericWithdecimal,
    _addNotification,
    getPaymentGatewayCharges,
    getPaymentGateway,
    convertTwoDecimalPoint,
    getLoginParent,
    getMurchantPayChargesStatus,
    calculateStripeCharges, calculateUPayCharges, calculatePayMayaCharges
} from "../../../server/util";
import PaymentModule from '../../Misc/PaymentModule/index.js';
import { transaction_Charge, transaction_Other_Charge, stripeInfo, currency_symbol, paymentGatewayOptions, paymentOptionValues } from '../../../server/constants'
var _ = require('lodash');
let murchantPayChargeStatus = false;
class CheckOut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            payModalObject: {
                mealSchoolId: 0,
                schoolName: '',
                logoUrl: '',
                transactionType: '',
                transactionDescription: '',
                checkNumb: '',
                isEqualDistSelected: false,
                totalTransactionAmount: 0.00,
                balAmount: 0.00,
                transactionFees: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                    
            }
        }
        this.computAmount = this.computAmount.bind(this);
        this.validatePayment = this.validatePayment.bind(this);
        this.onPaymentDone = this.onPaymentDone.bind(this);
        this.equalDistribute = this.equalDistribute.bind(this);
        this.showHideLoading = this.showHideLoading.bind(this)

    }
    componentWillMount = () => {
        const _selectedStudentsForPay = this.props.location.state.onSelectStudentsForPay || {};
        /* if(Object.keys(this.props.selectedStudentsForPay||{}).length>0){
            this.setState({payModalObject:this.props.selectedStudentsForPay}) ;
        }  */
        if (Object.keys(_selectedStudentsForPay || {}).length > 0) {
            this.setState({ payModalObject: _selectedStudentsForPay });
        }
        murchantPayChargeStatus = getMurchantPayChargesStatus(_selectedStudentsForPay.mealSchoolId || 0);
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    computAmount() {
        let payObj = this.state.payModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount == '' ? 0.00 : s.transactionAmount)
        });
        return isNaN(_computeAmount) ? 0.00 : _computeAmount;
    }
    validatePayment = () => {
        let isValid = false;
        let payObj = this.state.payModalObject;
        let _computAmount = this.computAmount()
        if (_computAmount > 0) {
            if (parseFloat(_computAmount.toFixed(2)) == parseFloat(payObj.totalTransactionAmount)) {
                isValid = true;
            }
        }
        return isValid
    }
    showHideLoading = (isShow) => {
        this.setState({ loading: isShow })
    }
    onToken = (data, isStripe) => {
        this.showHideLoading(true);
        let headers = {
            'Content-Type': 'application/json'
        };
        if (isStripe) {
            this.onPaymentDone({ status: 200 });
        } else {
            postWithHeaders("/transactions/depositAmtThruOnline?access_token=", JSON.stringify(data), headers)
                .then((response) => {
                    if (response.status === 200) {
                        this.onPaymentDone(response);
                    } else if (!response.ok) {
                        this.onPaymentDone(response);
                        throw Error(response);
                    }
                    this.showHideLoading(false)
                }).catch(
                    (error) => {
                        this.showHideLoading(false);
                        console.log('Payment error:', error);
                    }
                );
        }

    }
    onPaymentDone = (resp) => {
        if (resp.status == 200) {
            _addNotification('Lunch Balance added successfully.', this);
            setTimeout(() =>
                //this.props.history.push('/parent')
                window.location.replace('/parent')
                , 3000);
        } else {
            _addNotificationError('Failed to add payment ! Try again.', this);
        }
    }
    equalDistribute = (amount) => {
        amount = isNaN(amount) ? 0 : amount
        let payObj = this.state.payModalObject;
        if (amount != 0) {
            let distAmt = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            let balAmt = amount - (distAmt * payObj.studentWiseTransactions.length);
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = (amount / payObj.studentWiseTransactions.length).toFixed(2)
            })
            payObj.studentWiseTransactions[payObj.studentWiseTransactions.length - 1].transactionAmount = (distAmt + balAmt).toFixed(2);
        }
        else {
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = 0
            })
        }
        this.setState({ payModalObject: payObj })
    }
    render() {
        const sid = this.state.payModalObject.mealSchoolId || 0
        const customValue = (paymentGatewayOptions.PAYMOB !== getPaymentGateway(sid).payGatewayName || '') ? true : false;
        const charges = (murchantPayChargeStatus ? 0 : (paymentGatewayOptions.UNIONPAY == getPaymentGateway(sid).payGatewayName || '') ? calculateUPayCharges(this.computAmount(), false) :
            (paymentGatewayOptions.PAYMAYA == getPaymentGateway(sid).payGatewayName || '') ? calculatePayMayaCharges(this.computAmount(), false) :
                (paymentGatewayOptions.STRIPE === getPaymentGateway(sid).payGatewayName || '') ? (getPaymentGatewayCharges(sid, this.computAmount(), true)) : 0);
        return (
            <div>
                <section className="whiteSection full-width clearfix p-t-n">
                    <NotificationSystem ref="notificationSystem" />
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Add Lunch Balance {this.state.payModalObject.schoolName == '' ? '' : '- ' + this.state.payModalObject.schoolName}</span>
                                <button className="pull-right btn bg-color-4" style={{ margin: '0px', color: '#ffffff' }} onClick={(e) => {
                                    e.preventDefault();
                                    let _self = this;
                                    _self.context.router.history.goBack();
                                }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12">

                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12">

                                        <div className="form-group col-xs-12 col-sm-12 col-md-3">
                                            <label htmlFor="amount">Amount</label>
                                            <div className="input-group">
                                                <span className="input-group-addon" id="basic-addon1">{currency_symbol(this.state.payModalObject.mealSchoolId)}</span>
                                                {
                                                    customValue ?
                                                        <input type="text" className="form-control" style={{ textAlign: "right" }} maxLength="7" onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                            name="amount" value={isNaN(this.state.payModalObject.totalTransactionAmount) ? 0.00 : this.state.payModalObject.totalTransactionAmount}
                                                            placeholder="Amount" onChange={(e) => {
                                                                let payObj = this.state.payModalObject;
                                                                payObj.totalTransactionAmount = e.target.value;
                                                                payObj.balAmount = e.target.value;
                                                                payObj.transactionFees = parseFloat(convertTwoDecimalPoint(((payObj.totalTransactionAmount * transaction_Charge) + (payObj.totalTransactionAmount === 0 ? 0.00 : transaction_Other_Charge)), 2))
                                                                if (payObj.studentWiseTransactions.length === 1) {
                                                                    payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount;
                                                                }
                                                                else {
                                                                    if (this.state.isEqualDistSelected) {
                                                                        this.equalDistribute(parseFloat(payObj.totalTransactionAmount));
                                                                    }
                                                                }
                                                                this.setState({ payModalObject: payObj })
                                                            }} /> :

                                                        <select className="form-control" style={{ textAlign: "right" }} maxLength="7" name="amount" value={isNaN(this.state.payModalObject.totalTransactionAmount) ? 0.00 : this.state.payModalObject.totalTransactionAmount}
                                                            placeholder="Amount" onChange={(e) => {
                                                                let payObj = this.state.payModalObject;
                                                                payObj.totalTransactionAmount = e.target.value;
                                                                payObj.balAmount = e.target.value;
                                                                payObj.transactionFees = parseFloat(convertTwoDecimalPoint(((payObj.totalTransactionAmount * transaction_Charge) + (payObj.totalTransactionAmount === 0 ? 0.00 : transaction_Other_Charge)), 2))
                                                                if (payObj.studentWiseTransactions.length === 1) {
                                                                    payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount;
                                                                }
                                                                else {
                                                                    if (this.state.isEqualDistSelected) {
                                                                        this.equalDistribute(parseFloat(payObj.totalTransactionAmount));
                                                                    }
                                                                }
                                                                this.setState({ payModalObject: payObj })
                                                            }}>
                                                            <option value={''}></option>
                                                            {
                                                                (paymentOptionValues || []).map(item => {
                                                                    return <option value={item}>{item}</option>
                                                                })
                                                            }
                                                        </select>
                                                }
                                            </div>

                                        </div>

                                        {this.state.payModalObject.studentWiseTransactions.length > 1 ?
                                            <div className="form-group col-xs-12 col-sm-12 col-md-5">
                                                <label>Equally distribute</label>
                                                <div> <button type="button" className="btn-social btn-facebook btn-square" style={{ width: '34px', height: '34px' }} onClick={(e) => {
                                                    let payObj = this.state.payModalObject;
                                                    if (e.currentTarget.classList.contains('btn-facebook-filled')) {
                                                        e.currentTarget.childNodes[0].className = "fa fa-square-o";
                                                        this.setState({ isEqualDistSelected: false })
                                                    } else {
                                                        e.currentTarget.childNodes[0].className = "fa fa-check-square-o";
                                                        let amount = payObj.totalTransactionAmount;
                                                        this.equalDistribute(amount);
                                                        this.setState({ isEqualDistSelected: true })
                                                    }
                                                    e.currentTarget.classList.toggle('btn-facebook-filled');
                                                }} >
                                                    <i className="fa fa-square-o" ></i>
                                                </button></div>

                                            </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12">
                                        <div className="table-responsive">
                                            <table className="table table-payment-modal" >
                                                <thead><tr>
                                                    <th>Name</th>
                                                    <th style={{ width: '300px', textAlign: 'right' }}>Available Bal</th>
                                                    <th style={{ width: '300px', textAlign: 'right' }}>Amount</th></tr>
                                                </thead>
                                                <tbody style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                                                    {
                                                        this.state.payModalObject.studentWiseTransactions.map((row, key) => {
                                                            return (<tr>
                                                                <td>{row.name}</td>
                                                                <td style={{ width: '300px', textAlign: 'right' }}>{currency_symbol(this.state.payModalObject.mealSchoolId) + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                                <td style={{ width: '300px', textAlign: 'right' }}>
                                                                    <div className="input-group">
                                                                        <span className="input-group-addon" id="basic-addon1">
                                                                            {currency_symbol(this.state.payModalObject.mealSchoolId)}</span>
                                                                        {
                                                                            ((customValue) || (this.state.isEqualDistSelected === true)) ?
                                                                                <input type="text" style={{ zIndex: 1, textAlign: "right" }} maxLength="7"
                                                                                    disabled={this.state.payModalObject.studentWiseTransactions.length === 1 || this.state.isEqualDistSelected === true}
                                                                                    className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                    onChange={(e) => {
                                                                                        let payModel = this.state.payModalObject;
                                                                                        payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = e.target.value;
                                                                                        payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount == '' ? 0.00 : d.transactionAmount)))).toFixed(2));
                                                                                        payModel.balAmount = payModel.totalTransactionAmount;
                                                                                        payModel.transactionFees = parseFloat(convertTwoDecimalPoint(((payModel.totalTransactionAmount * transaction_Charge) + (payModel.totalTransactionAmount === 0 ? 0.00 : transaction_Other_Charge)), 2));
                                                                                        this.setState({ payModalObject: { ...payModel, balAmount: parseFloat(convertTwoDecimalPoint(payModel.balAmount, 2)) } });
                                                                                    }}
                                                                                    placeholder="Amount" /> :
                                                                                <select className="form-control" data-id={key} name="amount" value={row.transactionAmount}
                                                                                    placeholder="Amount" onChange={(e) => {
                                                                                        let payModel = this.state.payModalObject;
                                                                                        payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = e.target.value;
                                                                                        payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount == '' ? 0.00 : d.transactionAmount)))).toFixed(2));
                                                                                        payModel.balAmount = payModel.totalTransactionAmount;
                                                                                        payModel.transactionFees = parseFloat(convertTwoDecimalPoint(((payModel.totalTransactionAmount * transaction_Charge) + (payModel.totalTransactionAmount === 0 ? 0.00 : transaction_Other_Charge)), 2));
                                                                                        this.setState({ payModalObject: { ...payModel, balAmount: parseFloat(convertTwoDecimalPoint(payModel.balAmount, 2)) } });
                                                                                    }}>
                                                                                    <option value={''}></option>
                                                                                    {
                                                                                        (paymentOptionValues || []).map(item => {
                                                                                            return <option value={item}>{item}</option>
                                                                                        })
                                                                                    }
                                                                                </select>


                                                                        }

                                                                    </div></td>
                                                            </tr>)

                                                        })
                                                    }

                                                </tbody>
                                                <tfoot>
                                                    {
                                                        (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.payModalObject.mealSchoolId).payGatewayName || '') ?
                                                            <tr style={{ display: `${murchantPayChargeStatus ? 'none' : 'table'}` }}>
                                                                <td></td>
                                                                <td style={{ width: '300px', textAlign: 'right' }}>Platform fee:</td>
                                                                <td style={{ width: '300px', textAlign: 'right' }}>{currency_symbol(this.state.payModalObject.mealSchoolId) + ' ' + (charges).toFixed(2)}</td>
                                                            </tr> :
                                                            (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.payModalObject.mealSchoolId).payGatewayName || '') ?
                                                                <tr style={{ display: `${murchantPayChargeStatus ? 'none' : 'table'}` }}>
                                                                    <td></td>
                                                                    <td style={{ width: '300px', textAlign: 'right' }}>Transaction charges:</td>
                                                                    <td style={{ width: '300px', textAlign: 'right' }}>{currency_symbol(this.state.payModalObject.mealSchoolId) + ' ' + (charges).toFixed(2)}</td>
                                                                </tr> :
                                                                (paymentGatewayOptions.STRIPE === getPaymentGateway(sid).payGatewayName || '') ?
                                                                    <tr style={{ display: `${murchantPayChargeStatus ? 'none' : 'table'}` }}>
                                                                        <td></td>
                                                                        <td style={{ width: '300px', textAlign: 'right' }}>Transaction charges:</td>
                                                                        <td style={{ width: '300px', textAlign: 'right' }}>{currency_symbol(this.state.payModalObject.mealSchoolId) + ' ' + (charges).toFixed(2)}</td>
                                                                    </tr>
                                                                    : null
                                                    }
                                                    <tr>
                                                        <td></td>
                                                        <td style={{ width: '300px', textAlign: 'right' }}>Total Amount:</td>
                                                        <td style={{ width: '300px', textAlign: 'right' }}>{currency_symbol(this.state.payModalObject.mealSchoolId) + ' ' + (this.computAmount() + charges).toFixed(2)}</td></tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-right add-student-footer">
                                    <div className="row">

                                        <div className="col-md-2 col-sm-12 col-xs-12 pull-right">
                                            {
                                                this.validatePayment() === false ? <button className="btn btn-success btn-sm" style={{ margin: '0px 0px 0px 5px', paddingLeft: 0 }}>Pay With Card</button> :
                                                    <PaymentModule
                                                        paymentDesc={"LUNCH_BAL"}
                                                        schoolId={this.state.payModalObject.mealSchoolId}
                                                        schoolName={this.state.payModalObject.schoolName}
                                                        userInfo={{
                                                            parent: getLoginParent()
                                                        }}
                                                        paymentObj={this.state.payModalObject}
                                                        excludeCharges={murchantPayChargeStatus}
                                                        postDataForPayMaya={() => {
                                                            let selectedStudents = [];
                                                            this.state.payModalObject.studentWiseTransactions.map((s) => {
                                                                if (s.transactionAmount > 0) {
                                                                    selectedStudents.push({
                                                                        "studentRecId": s.studentRecId,
                                                                        "transactionAmount": s.transactionAmount
                                                                    });
                                                                }
                                                            });
                                                            let payObj = {
                                                                "mealSchoolId": this.state.payModalObject.mealSchoolId,
                                                                "transactionType": "Deposit",
                                                                "paymentType": "Online",
                                                                "paymentGateway": (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.payModalObject.mealSchoolId).payGatewayName || '') ? "UnionPay" : "PayMaya",
                                                                "transactionDescription": this.state.payModalObject.transactionDescription,
                                                                "totalTransactionAmount": this.state.payModalObject.totalTransactionAmount,
                                                                "transactionFees": getPaymentGatewayCharges(this.state.payModalObject.mealSchoolId, parseFloat(this.state.payModalObject.totalTransactionAmount), false),
                                                                "appFeeAmount": 0,//parseFloat(convertTwoDecimalPoint(calculateUPayCharges(this.state.payModalObject.totalTransactionAmount,false))),
                                                                "studentWiseTransactions": selectedStudents
                                                            };
                                                            return payObj;

                                                        }}
                                                        postDataForUnionPay={() => {
                                                            let selectedStudents = [];
                                                            this.state.payModalObject.studentWiseTransactions.map((s) => {
                                                                if (s.transactionAmount > 0) {
                                                                    selectedStudents.push({
                                                                        "studentRecId": s.studentRecId,
                                                                        "transactionAmount": s.transactionAmount
                                                                    });
                                                                }
                                                            });
                                                            let payObj = {
                                                                "mealSchoolId": this.state.payModalObject.mealSchoolId,
                                                                "transactionType": "Deposit",
                                                                "paymentType": "Online",
                                                                "paymentGateway": (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.payModalObject.mealSchoolId).payGatewayName || '') ? "UnionPay" : "PayMaya",
                                                                "transactionDescription": this.state.payModalObject.transactionDescription,
                                                                "totalTransactionAmount": this.state.payModalObject.totalTransactionAmount,
                                                                "transactionFees": getPaymentGatewayCharges(this.state.payModalObject.mealSchoolId, parseFloat(this.state.payModalObject.totalTransactionAmount), false),
                                                                "appFeeAmount": parseFloat(convertTwoDecimalPoint(calculateUPayCharges(this.state.payModalObject.totalTransactionAmount, false))),
                                                                "studentWiseTransactions": selectedStudents
                                                            };
                                                            return payObj;

                                                        }}
                                                        onToken={(token) => {
                                                            let selectedStudents = [];
                                                            this.state.payModalObject.studentWiseTransactions.map((s) => {
                                                                if (s.transactionAmount > 0) {
                                                                    selectedStudents.push({
                                                                        "studentRecId": s.studentRecId,
                                                                        "transactionAmount": s.transactionAmount
                                                                    });
                                                                }
                                                            });
                                                            let payObj = {
                                                                "mealSchoolId": this.state.payModalObject.mealSchoolId,
                                                                "transactionType": "Deposit",
                                                                "paymentType": "Online",
                                                                "transactionDescription": this.state.payModalObject.transactionDescription,
                                                                "totalTransactionAmount": this.state.payModalObject.totalTransactionAmount,
                                                                "transactionFees": getPaymentGatewayCharges(this.state.payModalObject.mealSchoolId, parseFloat(this.state.payModalObject.totalTransactionAmount), false),
                                                                "appFeeAmount": stripeInfo(this.state.payModalObject.mealSchoolId).application_free,
                                                                "studentWiseTransactions": selectedStudents
                                                            };
                                                            if (typeof (token) === 'string') {
                                                                payObj["transactionToken"] = token;
                                                            }
                                                            else {
                                                                payObj["transferId"] = token.transferId;
                                                                payObj["chargeId"] = token.chargeId;
                                                            }
                                                            this.onToken(payObj, true);
                                                        }}
                                                        //onPaymentDone={this.onPaymentDone} 
                                                        showHideLoading={this.showHideLoading}
                                                        onValidationError={(error) => {
                                                            _addNotificationError(error, this);
                                                        }}
                                                    />

                                            }
                                            {/* <StripeCheckOut reqObject={this.state.payModalObject} 
                                                    onPaymentDone={this.onPaymentDone} 
                                                    showHideLoading={this.showHideLoading} 
                                                    onValidationError={(error)=>{
                                                        _addNotificationError(error,this);

                                                    }} /> */}

                                        </div>
                                        <div className="col-md-2 col-sm-12 col-xs-12 pull-right">
                                            <button type="button" className="btn btn-primary btn-sm" style={{ margin: '0px 0px 0px 5px', paddingLeft: 0 }}
                                                onClick={() => this.props.history.push('/parent')}
                                            ><i
                                                className="glyphicon glyphicon-remove"
                                            ></i> Cancel
                                            </button>
                                        </div>
                                    </div>


                                </div>


                            </div>
                        </div>

                    </div>
                </section>
            </div>);
    }
}
CheckOut.contextTypes = {
    router: PropTypes.object.isRequired
}
export default CheckOut;


// WEBPACK FOOTER //
// ./src/components/Parent/CheckOut/checkOut.jsx